<script lang="ts">
	// This is very similar to /shared/component/ErrorMessage.svelte, but this is for the storefront
	export let message: string = ``
	export let server_error_response: any = null
</script>

{#if server_error_response}
	{#if Array.isArray(server_error_response?.errors)}
		{#each server_error_response.errors as error}
			{#if error.message}
				<p>{error.message}</p>
			{:else}
				<pre>{JSON.stringify(error)}</pre>
			{/if}
		{/each}
	{:else}
		<pre>{JSON.stringify(server_error_response)}</pre>
	{/if}
{:else}
	<p>{message}</p>
{/if}

<style>
	p, pre {
		color: rgb(231, 85, 26);
	}
</style>
